import React from 'react';
import {useOutlet} from 'reconnect.js';
import styled from 'styled-components';
import {ArrowRightCircle} from '@styled-icons/bootstrap/ArrowRightCircle';
import constants from '../../../constants';
import * as AppActions from '../../../AppActions';

function AboutSection(props) {
  const {landing} = props;
  const about_section = landing?.custom_layout.about_section;

  return (
    <Wrapper id="creator-section">
      <div className="content">
        <div className="container">
          <div className="photos">
            <img
              className="landing-about-bottom"
              alt="landing-about-bottom"
              src={
                about_section?.bottom_image ||
                '/images/landing-about-bottom.jpg'
              }
            />
            <img
              className="landing-about-top"
              alt="landing-about-top"
              src={about_section?.top_image || '/images/landing-about-top.jpg'}
            />
          </div>
        </div>
        <div className="container">
          <div className="intros">
            <div className="title-container inner">
              <h2>關於好好選</h2>
              <h3>About HoHoKing</h3>
            </div>
            <p className="desp">
              {about_section?.description ||
                `好好選 HoHoKing 是一個提供創作者發行個人商品的平台，我們將創意轉化為實體，讓少量發行不再是難以成立的想法。\n\n好好選 HoHoKing 希望挖掘更尚未被發現的創意人，尋找許多有趣的IP合作，讓更多的人好好地挑選適合自己的商品，並支持自己喜愛的藝術家、創作者或設計師。\n\n現在，將你的創意投入，讓你的想像得以實踐。`}
            </p>
            <div className="gutter" />
            <div className="action">
              <button onClick={() => AppActions.navigate('/about')}>
                <span>瞭解更多</span>
                <ArrowRightCircle size={20} color={constants.THEME_COLOR} />
              </button>
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  padding: 40px 40px 200px 40px;

  & > .content {
    margin: 0 auto;
    max-width: var(--contentMaxWidth);
    width: 100%;
    display: flex;

    & > .container {
      flex: 2;

      display: flex;
      flex-direction: column;

      position: relative;

      & > .photos {
        padding-bottom: 100px;

        & > img {
          max-width: 60%;
          width: 100%;
        }

        & > .landing-about-top {
          position: absolute;
          top: 100px;
          right: 40px;
        }
      }

      & > .intros {
        flex: 1;
        padding-top: 100px;
        display: flex;
        flex-direction: column;

        & > .inner {
          margin-bottom: 40px;
          text-align: left;
          padding: 0px 15px;
        }

        & > .desp {
          padding: 0px 15px;
          max-width: 500px;
          width: 100%;
          text-align: left;
          white-space: pre-wrap;
          letter-spacing: 1.02px;
        }

        & > .gutter {
          flex: 1;
          min-height: 40px;
        }

        & > .action {
          max-width: 500px;
          width: 100%;
          padding: 0px 15px;
          display: flex;
          justify-content: flex-end;

          & > button {
            cursor: pointer;
            border: none;
            background-color: transparent;

            &:hover {
              & > span {
                font-weight: 500;
              }
            }
          }

          & > button > span {
            margin-right: 10px;
            color: var(--primaryColor);
          }
        }

        @media screen and (max-width: 1000px) {
          padding: 0px;
        }

        @media screen and (max-width: 600px) {
          & > .inner {
            margin-bottom: 20px;
          }

          & > .desp {
            font-size: 0.8rem;
          }
        }
      }
    }
  }

  @media screen and (max-width: 500px) {
    padding: 20px 20px 200px 20px;
    & > .content {
      flex-direction: column;

      & > .container > .photos {
        margin-bottom: 50px;

        & > .landing-about-top {
          right: 0px;
        }
      }
    }
  }
`;

export default AboutSection;
